export default "__VITE_ASSET__4870361f__"